export default "__VITE_ASSET__CRZXhmHY__"